export default {"src":"/_next/static/media/profileAccount.0de49ddf.svg","height":28,"width":28};